export default __webpack_public_path__ + "static/media/Zelle.9cd77106.png";